export const MY_SIZE_PROFILE_OPEN_MODAL_EVENT = "sizePickerOpen";
